import React, { Component } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import { Link } from "react-router-dom";
import "./Team.css";

class Team extends Component {
  state = {
    activeMember: null,
  };

  handleCardClick = (member) => {
    this.setState({ activeMember: member });
  };

  renderTeamMember(name, position, imageClass, bio) {
    return (
      <div
        className="team-card"
        key={name}
        onClick={() =>
          this.setState({
            activeMember: { name, position, img: imageClass, bio },
          })
        }
      >
        <div className={`team-image ${imageClass}`}></div>
        <h3>{name}</h3>
        <p>{position}</p>
        <span className="view-details">View Details</span>
      </div>
    );
  }

  render() {
    // const { activeMember } = this.state;

    return (
      <div>
        <Header />

        <div className="team-hero">
          <div className="team-hero-content container">
            <h1>Our Team</h1>
            <p>
              <Link to="/" className="team-breadcrumb-home">
                Home
              </Link>
              <span className="team-breadcrumb-separator"> / </span>
              <span className="team-breadcrumb-current"> Team</span>
            </p>
          </div>
        </div>
        <div className="section container">
          <div
            className="site-text-color pb-4 text-center"
            style={{ marginTop: "-5px", fontSize: "20px", fontWeight: "900" }}
          >
            Meet The Wealth System Team
          </div>
          <label className="text-left" style={{ textAlign: "justify" }}>
            <b style={{ fontSize: "30px" }}>T</b>he Wealth System is one of the
            creations of Rauxmac Integrated Concepts, an idea identification,
            development and promotion company, whose activities presently
            domicile in Nigeria. The Wealth System is a symbiotic project where
            everyone involved has something good to benefit. The project is
            carried out by a 4 Man Team whose short profiles are as follows:
          </label>
        </div>

        <div
          className=" section py-5  container "
          style={{ backgroundColor: "#eee", borderRadius: "20px" }}
        >
          <div className="row">
            <div className="col-lg-4  text-center pt-3">
              <img
                src="emeh.jpg"
                style={{ width: "80%", borderRadius: "50px" }}
              />
            </div>
            <div className="  col-lg-7">
              <div>
                <div className="pt-4">
                  <h3>Mr. Emeh Emmanuel Chukwuemeka</h3>
                  <p>Project Creator and Team leader</p>
                </div>
                <b style={{ fontSize: "30px" }}>E</b>meh Emmanuel Chukwuemeka is
                a Nigerian from Imo State, natural scientist and a deep creative
                thinking expert. The Wealth System is the latest child of his
                brain, the product of his creativity and the materialization of
                his inventive genius. He created the system to raise new
                generations of world industrialists from ashes through what he
                termed &quot;Indirect Crowd Funding &quot; (ICF), since users
                pay for the use of his system to cultivate. That is performing
                assigned tasks and getting rewards upon 100% task
                accomplishment. He is also the Author of &quot;The Gifted&quot;,
                a book he wrote to foster gift identification, development and
                mastering, and also encourage the gifted youths to leverage on
                their gifts to master the principles of existence as it holds
                the key to finding solutions to most extremely difficult
                problems that have no known solutions yet. He also created
                &quot;Assessment Poll &quot; <br></br>(
                <a
                  href="https://www.assessmentpoll.com"
                  target="blank"
                  style={{ color: "orange" }}
                >
                  https://www.assessmentpoll.com
                </a>
                ) in pursuance of his competent leadership advocacy, an online
                election running platform designed for SUGs, Professional
                bodies, Trade Unions and Institutions to carry out leadership
                elections without compromising the integrity and credibility of
                the process. He is a solution provider and a highly empathetic
                person, which necessitated his invention of an automatic
                sterilizing machine (
                <a
                  href="https://youtube.com/shorts/bFfLNyCoLU0?si=0_sMt68FX7MV68at "
                  target="blank"
                  style={{ color: "orange" }}
                >
                  https://youtube.com/shorts/bFfLNyCoLU0?si=0_sMt68FX7MV68at
                </a>
                ) during the COVID-19 pandemic to save humanity from extinction,
                under the supervision of an NGO, Rauxmac International
                Initiative, which he is also the founder. The machine uses three
                major things, UV light, heater and disinfectant spray, of which
                each component has the capacity of destroying virus alone. But
                as a perfectionist, he chooses to indulge the three for optimal
                result. He is indeed a rear germ and blessing to humanity.
                humanity.
              </div>
            </div>
          </div>
        </div>

        <div
          className=" section py-5  mt-5 mb-5 container "
          style={{ backgroundColor: "#eee", borderRadius: "20px" }}
        >
          <div className="row align-items-center" style={{ minHeight: "100%" }}>
            <div className="col-lg-4 text-center pt-3">
              <img
                src="barr.jpg"
                style={{ width: "80%", borderRadius: "50px" }}
              />
            </div>

            <div className="col-lg-4 d-flex align-items-center">
              <div>
                <h3>Dr. Barr. Ifeanyi Nwosu</h3>
                <p>Legal Adviser</p>
                <p>
                  <b style={{ fontSize: "30px" }}>D</b>r Barr Ifeanyi Nwosu is
                  the principal partner of Compendium Chambers and a seasoned
                  legal practitioner of the Supreme Court of Nigeria.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          className=" section py-5  mt-5 mb-5 container "
          style={{ backgroundColor: "#eee", borderRadius: "20px" }}
        >
          <div className="row">
            <div className="col-lg-4  text-center pt-3">
              <img
                src="lucy.jpg"
                style={{ width: "80%", borderRadius: "50px" }}
              />
            </div>
            <div className="  col-lg-7">
              <div>
                <div>
                  <div className="pt-4"></div>
                  <h3>Eberechukwu Lucy</h3>
                  <p>Team Sec.</p>
                </div>
                <b style={{ fontSize: "30px" }}>A </b> seasoned Food Scientist,
                Technologist, and Researcher with a passion for transforming the
                food industry. As the CEO of Luem Agro Processing & Packaging
                Enterprise, she&apos;s dedicated to promoting sustainable food
                systems and improving nutrition and food security.
                <br />
                <br />
                <b>Mission:</b>
                <br />
                Committed to upscaling the adoption of underutilized foods,
                driving innovation, and promoting sustainable food systems.
                Through her work, she aims to make a positive impact on the
                environment, human health, and local communities.
                <br />
                <br />
                <b>Expertise:</b>
                <br />
                <br />
                With a strong background in food science and technology, she{" "}
                <b>specializes in:</b>
                <br />
                - Agro-processing and packaging
                <br />
                - Research and development of underutilized foods
                <br />
                - Nutrition and food security advocacy
                <br />
                - Food product development and innovation
                <br />
                <br />
                <br />
                <b>Achievements:</b>
                <br />
                - Published author of books on underutilized foods and nutrition
                <br />
                - Developed innovative food products that promote nutrition and
                food security
                <br />
                - Established Luem Agro Processing & Packaging Enterprise as a
                leading player in the agro-processing industry
                <br />
                <br />
                <b>Collaborations and Partnerships:</b>
                <br />
                She has collaborated with renowned institutions to promote
                underutilized crops and improve food security: - Partnered with
                Raw Materials Research and Development Council (RMRDC) to
                promote the adoption of underutilized crops
                <br />
                - Stakeholder, Nigeria Stored Products Research Institute
                (NSPRI), contributing to research and development in food
                storage and processing.
                <br />
              </div>
            </div>
          </div>
        </div>

        <div
          className=" section py-5  mt-5 mb-5 container "
          style={{ backgroundColor: "#eee", borderRadius: "20px" }}
        >
          <div className="row">
            <div className="col-lg-4  text-center pt-3">
              <img
                src="shed.jpg"
                style={{ width: "90%", borderRadius: "50px" }}
              />
            </div>
            <div className="  col-lg-4">
              <div>
                <div>
                  <div className="pt-4"></div>
                  <h3>Mr. Tabansi shedrack</h3>
                  <p>Front-end developer</p>
                </div>
                <b style={{ fontSize: "30px" }}>T</b>abansi Shedrack is a
                skilled front-end developer with experience in crafting
                responsive web pages and interactive features using HTML, CSS,
                JavaScript, and React.js. With a solid foundation in web
                development and a keen eye for detail, Shedrack has worked on
                various projects, collaborating with teams to deliver
                high-quality solutions. Holding a degree in Computer Science
                from the University of Benin, Shedrack continues to grow and
                innovate in the field of front-end development.
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

export default Team;
